import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  kycDirectorOneInitialValues,
  KycDirectorOneInterface,
} from '../../models/dashboard/configuration/kycDirectorOne';
import {
  kycDirectorTwoInitialValues,
  KycDirectorTwoInterface,
} from '../../models/dashboard/configuration/kycDirectorTwo';

interface IInitialState {
  kycDirectorOne: KycDirectorOneInterface;
  kycDirectorTwo: KycDirectorTwoInterface;
}

const initialState: IInitialState = {
  kycDirectorOne: kycDirectorOneInitialValues,
  kycDirectorTwo: kycDirectorTwoInitialValues,
};

const kycInformationSlice = createSlice({
  name: 'kycInformation',
  initialState,
  reducers: {
    setKycDirectorOneSlider(state, action: PayloadAction<KycDirectorOneInterface>) {
      state.kycDirectorOne = action.payload;
    },
    setKycDirectorTwoSlider(state, action: PayloadAction<KycDirectorTwoInterface>) {
      state.kycDirectorTwo = action.payload;
    },

    reset: () => initialState,
  },
});

export const kycInformationActions = kycInformationSlice.actions;
export default kycInformationSlice.reducer;
